<template>
  <dialog
    ref="helpDialog"
    class="mx-auto my-auto shadow-lg"
    data-cy="help-modal"
    @click.self="closeDialog"
  >
    <div class="space-y-4 p-4">
      <template v-for="group in groupedShortcuts" :key="group.context">
        <lf-h3 class="text-white/80">{{ group.context }}</lf-h3>
        <div class="help-grid grid grid-cols-2">
          <template
            v-for="shortcut in group.shortcuts"
            :key="shortcut.action_name"
          >
            <div>{{ formatActionName(shortcut.action_name) }}</div>
            <div class="text-right">{{ shortcut.action }}</div>
          </template>
        </div>
      </template>
    </div>
  </dialog>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";

import { useKeyboardShortcuts } from "@/hooks/keyboardShortcuts";

import LfH3 from "@/components/ui/text/LfHeading3.vue";

const emit = defineEmits<{
  close: [];
}>();

const { groupedShortcuts, formatActionName } = useKeyboardShortcuts();

const helpDialog = ref<HTMLDialogElement>();

const closeDialog = () => {
  if (helpDialog.value?.open) {
    helpDialog.value.close();
    emit("close");
  }
};

onMounted(() => {
  helpDialog.value?.addEventListener("cancel", closeDialog);
  helpDialog.value?.showModal();
});
</script>

<style scoped>
@reference "@/assets/tailwind.css";

.help-grid > div {
  @apply border-t border-white/50 py-2;
  &:nth-child(1),
  &:nth-child(2) {
    @apply border-t-0;
  }
}

dialog {
  @apply w-[600px] rounded-md bg-login-bg text-white/80;
  &:focus-within {
    @apply outline-none;
  }
  &::backdrop {
    backdrop-filter: blur(0.5px);
  }
}
</style>
